// extracted by mini-css-extract-plugin
export default {"trigger":"Hamburger-module--trigger--5d029","fakeActive":"Hamburger-module--fakeActive--b718e"};